import { Anchor, Group, Stack, Text } from "@mantine/core"
import { DefaultList } from "../../../../-components/default-list"
import { usePlanLayoutAttachmentApi } from "../../../../attachment-api/planLayoutAttachmentApi"
import { PlanLayoutAttachmentDto } from "../../../../@client/Theasoft_ApiServer_Attachments"
import { getFormattedPeriod } from "../../../../components/absences/getFormattedPeriod"
import { getFormattedDate } from "../../../../utils/get-formatted-date"
import { useTranslation } from "react-i18next"
import { ActionIconPencil } from "../../../../-components/action-icons"
import { PlanLayoutAttachmentEditModal } from "./PlanLayoutAttachmentEditModal"
import { useDisclosure } from "@mantine/hooks"
import { LabeledValue } from "../../../../-components/default-list/labeled-value"
import { DefaultListItem } from "../../../../-components/default-list/list-item"
import { useSuspenseQueryGet } from "../../../../typed-client/hooks/use-suspense-query-get"

interface Props {
  attachments: [string, PlanLayoutAttachmentDto[]][]
  withoutGroupHeader?: boolean
}

export function PlanLayoutAttachmentList({
  attachments,
  withoutGroupHeader,
}: Props) {
  return (
    <Stack>
      {attachments.map(([key, attachments], index) => (
        <React.Fragment key={key + "-" + index}>
          {!withoutGroupHeader && (
            <Text fz="xl" fw={"bold"}>
              {key}
            </Text>
          )}
          <DefaultList
            divider
            data={attachments}
            renderItem={({ entity: item }) => <ListItem item={item} />}
          />
        </React.Fragment>
      ))}
    </Stack>
  )
}

function ListItem({ item }: { item: PlanLayoutAttachmentDto }) {
  const [editModalOpened, { open: openEditModal, close: closeEditModal }] =
    useDisclosure()
  const planLayoutAttachmentApi = usePlanLayoutAttachmentApi()
  const { getFileUrl } = planLayoutAttachmentApi

  const { data: canPublishPlan } = useSuspenseQueryGet(
    "/api/Plans/CanPublishPlans",
    item.planLayoutId
  )

  const { t } = useTranslation("app_server")

  return (
    <DefaultListItem>
      <Group justify="space-between" w={"100%"}>
        <Anchor
          target="_blank"
          href={getFileUrl(item.attachmentId, item.planLayoutId)}
          underline="hover"
          c={"var(--mantine-color-text)"}
        >
          <LabeledValue
            label={
              <Text>
                {getFormattedPeriod(
                  {
                    startDate: item.startDate,
                    startTime: "00:00:00",
                    endTime: "00:00:00",
                    endDate: item.endDate,
                  },
                  "L",
                  true
                )}
              </Text>
            }
            value={
              <Text fw="lighter">
                {`${t("PlanAttachment_Version")}: ${getFormattedDate(item.createdAt, "L LT")}${item.description ? ", " + item.description : ""}`}
              </Text>
            }
          />
        </Anchor>
        {canPublishPlan && <ActionIconPencil onClick={openEditModal} />}
      </Group>
      {canPublishPlan && (
        <PlanLayoutAttachmentEditModal
          planLayoutAttachment={item}
          opened={editModalOpened}
          onClose={closeEditModal}
        />
      )}
    </DefaultListItem>
  )
}
